import React from 'react'
import withIcon from '@/components/withIcon'

const IconTherapies = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="path-1-outside-1_3800_100826"
        maskUnits="userSpaceOnUse"
        x="5"
        y="3"
        width="12"
        height="12"
        fill="black"
      >
        <rect
          fill="white"
          x="5"
          y="3"
          width="12"
          height="12"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 5H10V8L7 8V10H10V13H12V10H15V8L12 8V5Z"
        />
      </mask>
      <path
        d="M10 5V3.5C9.17157 3.5 8.5 4.17157 8.5 5H10ZM12 5H13.5C13.5 4.17157 12.8284 3.5 12 3.5V5ZM10 8V9.5C10.8284 9.5 11.5 8.82843 11.5 8H10ZM7 8L7 6.5C6.17157 6.5 5.5 7.17157 5.5 8H7ZM7 10H5.5C5.5 10.8284 6.17157 11.5 7 11.5V10ZM10 10H11.5C11.5 9.17157 10.8284 8.5 10 8.5V10ZM10 13H8.5C8.5 13.8284 9.17157 14.5 10 14.5V13ZM12 13V14.5C12.8284 14.5 13.5 13.8284 13.5 13H12ZM12 10V8.5C11.1716 8.5 10.5 9.17157 10.5 10H12ZM15 10V11.5C15.8284 11.5 16.5 10.8284 16.5 10H15ZM15 8H16.5C16.5 7.60218 16.342 7.22064 16.0607 6.93934C15.7794 6.65804 15.3978 6.5 15 6.5V8ZM12 8H10.5C10.5 8.39783 10.658 8.77936 10.9393 9.06066C11.2206 9.34197 11.6022 9.5 12 9.5V8ZM10 6.5H12V3.5H10V6.5ZM11.5 8V5H8.5V8H11.5ZM7 9.5L10 9.5V6.5L7 6.5L7 9.5ZM8.5 10V8H5.5V10H8.5ZM10 8.5H7V11.5H10V8.5ZM11.5 13V10H8.5V13H11.5ZM12 11.5H10V14.5H12V11.5ZM10.5 10V13H13.5V10H10.5ZM15 8.5H12V11.5H15V8.5ZM13.5 8V10H16.5V8H13.5ZM12 9.5H15V6.5L12 6.5V9.5ZM10.5 5V8H13.5V5H10.5Z"
        fill="#162941"
        mask="url(#path-1-outside-1_3800_100826)"
      />
      <path
        d="M3.84294 24C3.84294 23.5538 4.13843 20.9836 4.13843 18.4025C4.13843 15.9999 3 13.9999 3 8.99994C3 4.58166 6.58172 1 11 1C15.4183 1 19 4.58166 19 8.99994L22 15.1898L19.1928 15.4575C19.1928 16.5 18.3064 20.3856 18.3064 20.3856C18.3064 20.3856 15.45 20.4749 14.7605 20.3856V24"
        stroke="#162941"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default withIcon(IconTherapies)
